// pages/404.js
import { createTheme, ThemeProvider } from '@mui/material';
import cn from 'classnames';
import Head from 'next/head';
import React from 'react';
import { withLayout } from '../Layout/Layout';
import Link from 'next/link';
import styles from '../styles/modules/Archive.module.scss';
import SwedenFlag from '../public/images/sweden.svg';
import DenmarkFlag from '../public/images/denmark.svg';
import UKFlag from '../public/images/united-kingdom.svg';
import NorwayFlag from '../public/images/norway.svg';

const theme = createTheme({
  palette: {
    primary: {
      main: '#00454A',
    },
    secondary: {
      main: '#202020',
    },
  },
  typography: {
    fontFamily: '"Libre Franklin", sans-serif',
    color: '#202020',
  },
});

function Archive() {
  const languages = [
    {
      value: 'gb',
      image: <UKFlag />,
      title: 'English',
    },
    {
      value: 'se',
      image: <SwedenFlag />,
      title: 'Swedish',
    },
    {
      value: 'no',
      image: <NorwayFlag />,
      title: 'Norwegian',
    },
    {
      value: 'dk',
      image: <DenmarkFlag />,
      title: 'Danish',
    },
  ];

  return (
    <ThemeProvider theme={theme}>
      <Head>
        <link rel="canonical" href={`${process.env.apiUrl}/archive`} />
        <title>Explore Our Article Archive: Travel Insights and Stories</title>
      </Head>
      <div className={cn(styles.archiveCountrySelectContainer, 'container')}>
        <h1 className="w-full text-center font-fragment text-5xl my-8">
          Archive articles
        </h1>
        {languages.map((lang) => (
          <Link key={lang.value} href={`/archive/${lang.value}`}>
            <div className={styles.archiveCountrySelectItem}>
              <div className={styles.archiveItemImage}>
                <div className={styles.archiveImageContainer}>{lang.image}</div>
              </div>
              <div className={cn(styles.archiveItemTitle, 'font-libre')}>
                {lang.title}
              </div>
            </div>
          </Link>
        ))}
      </div>
    </ThemeProvider>
  );
}

export default withLayout(Archive, false);
